import { MapSearchInput } from '../utils/queryUtils'

export const debtorsTableFields: MapSearchInput['path'] = {
    name: ['name', 'identifier.value'],
    number: ['identifier.value']
}
